/*
 * Copyright © 2022 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import {Injectable} from '@angular/core';
import type {SupportedLocale} from '@dv/shared/code';
import type {Translation, TranslocoLoader} from '@jsverse/transloco';
import type {Observable} from 'rxjs';
import {from} from 'rxjs';
import {translationLoader} from './translation-loader';

@Injectable({providedIn: 'root'})
export class KitAdminTranslationLoader implements TranslocoLoader {

    public getTranslation(locale: SupportedLocale): Observable<Translation> {
        return from(translationLoader(locale));
    }
}
